import { render, staticRenderFns } from "./ProductValueYieldStatistics.vue?vue&type=template&id=0d60ecbc&scoped=true&"
import script from "./ProductValueYieldStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductValueYieldStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductValueYieldStatistics.vue?vue&type=style&index=0&id=0d60ecbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60ecbc",
  null
  
)

export default component.exports